import { render } from "./WithdrawalsList.vue?vue&type=template&id=633f8046&scoped=true"
import script from "./WithdrawalsList.vue?vue&type=script&lang=js"
export * from "./WithdrawalsList.vue?vue&type=script&lang=js"

import "./WithdrawalsList.vue?vue&type=style&index=0&id=633f8046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633f8046"]])

export default __exports__